<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <MerchantMultiselect :multiple="true" v-model="merchantsFilter">
                      </MerchantMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <StoreMultiselect :multiple="true" v-model="storesFilter">
                      </StoreMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <TrafficGroupMultiselect :multiple="true" small v-model="trafficGroupsFilter">
                      </TrafficGroupMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.from_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.to_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <TraderMultiselect @update:model-value="onTraderListUpdate" :multiple="true" v-model="tradersFilter">
                      </TraderMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="statuses"
                                   class="multiselect-sm"
                                   v-model="requestDTO.statuses"
                                   :options="Object.values(DealStatus)"
                                   :custom-label="(opt) => helper.trans(`deal_status.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.statuses')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="methods"
                                   class="multiselect-sm"
                                   v-model="requestDTO.methods"
                                   :options="store.getters['currencyMethods/methods']()"
                                   :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_methods')"
                      >
                        <template #option="props">
                          <div class="d-flex flex-row align-items-center gap-2">
                            <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                            <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="options"
                                   class="multiselect-sm"
                                   v-model="requestDTO.options"
                                   :options="store.getters['currencyMethods/options']()"
                                   :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_options')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="types"
                                   class="multiselect-sm"
                                   v-model="requestDTO.types"
                                   :options="Object.values(Direction)"
                                   :custom-label="(opt) => helper.trans(`direction.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.type')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div  class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <DevicesMultiselect ref="deviceMultiselect" :multiple="true" :trader-ids="tradersFilter.map((item) => item.id)" v-model="devicesFilter">
                      </DevicesMultiselect>
                    </div>
                  </div>
                </div>

                <div  class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <TeamLeadMultiselect :multiple="false" v-model="teamLeadFilter"></TeamLeadMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="currency"
                                   class="multiselect-sm multiselect-capitalize"
                                   v-model="requestDTO.currency"
                                   :options="store.getters['currencyMethods/currencies']"
                                   :custom-label="(opt) => opt"
                                   :multiple="false"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.currency')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountFrom" class="form-control form-control-sm" :placeholder="helper.trans('labels.from_sum')" />
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountTo" class="form-control form-control-sm" :placeholder="helper.trans('labels.to_sum')" />
                    </div>
                  </div>
                </div>

                <div class="form-group pb-2 pe-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="form-check small mb-0 mt-1">
                      <input class="form-check-input" v-model="requestDTO.onlyProviders" true-value="1" type="checkbox" value="" id="turnoverOnlyProviders">
                      <label class="form-check-label" for="turnoverOnlyProviders">
                        {{ helper.trans('labels.only_providers') }}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                    <button type="button" @click.prevent="() => startExport()" class="btn btn-outline-primary btn-sm rounded-pill text-capitalize-first">
                      <i class="fa-solid fa-download"></i> {{ helper.trans('statistic.turnoverSummary.export') }}
                    </button>
                  </div>
                </div>

              </div>
              <div class="row mt-3">
                <div class="form-group mb-2 col-auto me-2">
                  <div class="col p-0">
                    <div class="d-flex align-items-center flex-nowrap">
                      <label class="me-2 mb-0">{{helper.trans('labels.group_by')}}</label>
                      <input type="radio" v-model="requestDTO.groupBy" value="store" class="btn-check" name="turnover-group-by" id="turnover-group-stores" autocomplete="off" checked>
                      <label class="btn btn-sm btn-outline-dark" for="turnover-group-stores"> {{helper.trans('labels.stores')}}</label>
                      <input type="radio" v-model="requestDTO.groupBy" value="trader" class="btn-check" name="turnover-group-by" id="turnover-group-traders" autocomplete="off">
                      <label class="btn btn-sm btn-outline-dark ms-2" for="turnover-group-traders">{{helper.trans('labels.traders')}}</label>
                      <input type="radio" v-model="requestDTO.groupBy" value="provider" class="btn-check" name="turnover-group-by" id="turnover-group-providers" autocomplete="off">
                      <label class="btn btn-sm btn-outline-dark ms-2" for="turnover-group-providers">{{helper.trans('labels.providers')}}</label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-auto">
                  <div class="col p-0">
                    <div class="form-check small mb-0 mt-2">
                      <input class="form-check-input" v-model="showByFiat" type="checkbox" id="turnoverShowByFiat">
                      <label class="form-check-label" for="turnoverShowByFiat">
                        {{ helper.trans('statistic.turnoverSummary.byFiat') }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="card card-body mb-0">
              <div class="overflow-auto">
                <table class="table table-bordered align-middle text-left text-nowrap position-relative">
                  <template v-for="group in groups" :key="group.groupId">
                    <thead>
                    <tr>
                      <th colspan="20" class="text-center bg-secondary text-white">
                        <span v-if="group.groupId === '0'" class="text-center mb-2 text-capitalize">
                          {{ helper.trans('labels.total') }}
                        </span>
                        <span v-else-if="group.store" class="text-center mb-2">
                          {{ `${group.store?.merchantName} - ${group.store?.name}` }}
                        </span>
                        <span v-else-if="group.trader" class="text-center mb-2">
                          {{ group.trader?.name }} <span v-if="group.trader?.email.length > 0">({{group.trader?.email}})</span>
                        </span>
                        <span v-else class="text-center mb-2">#{{ group.groupId }}</span>
                      </th>
                    </tr>
                    </thead>
                  <template v-for="direction in group.directions" :key="direction">
                    <thead>
                    <tr>
                      <th colspan="20" class="text-center text-capitalize">
                        {{ helper.trans(`direction.${direction}`) }}
                      </th>
                    </tr>
                    </thead>
                    <thead>
                    <tr class="bg-light">
                      <th rowspan="2" class="text-capitalize-first" style="width: 0;">{{ helper.trans('labels.metric') }}</th>
                      <th rowspan="2" class="text-capitalize-first text-wrap" style="width: 0;">{{ helper.trans('labels.operations_count') }}</th>
                      <th rowspan="2" class="text-capitalize-first text-wrap" style="width: 0;">{{ helper.trans('labels.deals_count') }}</th>
                      <th rowspan="2" class="text-capitalize-first text-wrap" style="width: 0;">{{ helper.trans('labels.fiat_sum') }}</th>
                      <th rowspan="2" class="text-capitalize-first text-wrap" style="width: 0;">
                        {{ direction === Direction.PAY_IN ? helper.trans('labels.trader_sum_out') : helper.trans('labels.trader_sum_in') }}
                      </th>
                      <th rowspan="2" class="text-capitalize-first text-wrap" style="width: 0;">
                        {{ direction === Direction.PAY_IN ? helper.trans('labels.store_sum_in') : helper.trans('labels.store_sum_out') }}
                      </th>
                      <th rowspan="2" class="text-capitalize-first text-wrap" style="width: 0;">{{ helper.trans('labels.store_fee_sum') }}</th>
                      <th :colspan="rewardColumnsCount" class="text-center p-0">{{ helper.trans('labels.rewards') }}</th>
                    </tr>
                    <tr class="bg-light">
                      <th class="text-capitalize-first text-center" style="width: 0;">{{ helper.trans('labels.trader') }}</th>
                      <th class="text-capitalize-first text-center" style="width: 0;">{{ helper.trans('labels.teamlead') }}</th>
                      <th class="text-capitalize-first text-center" style="width: 0;">{{ helper.trans('labels.referral') }}</th>
                      <th class="text-capitalize-first text-center" style="width: 0;">{{ helper.trans('labels.service') }}</th>
                      <template v-if="partners.length > 0">
                        <th v-for="partner in partners" :key="partner.userId" class="text-capitalize-first text-center" style="width: 0;">{{ partner.name }}</th>
                        <th class="text-capitalize-first text-center" style="width: 0;">{{ helper.trans('labels.rest_of') }}</th>
                      </template>
                    </tr>
                    </thead>
                    <tbody class="text-end">
                    <tr v-for="item in group.itemsByDirection[direction]" :key="item.metric" :class="metricRowClass(item.metric)">
                      <td class="text-capitalize-first text-start">{{ helper.trans(`statistic.turnoverSummary.metric.${item.metric}`) }}</td>
                      <td class="text-start">{{ numberFormatter.formatNumber(item.operationsCount) }}</td>
                      <td class="text-start">{{ numberFormatter.formatNumber(item.dealsCount) }}</td>
                      <td>
                        <div v-for="(sum, currency) in item.fiatSums" :key="currency">
                          {{ numberFormatter.formatMoney(sum) }}
                        </div>
                      </td>
                      <td v-for="column in moneyColumns" :key="column">
                        <div v-for="(line, index) in cellLines(item, column)" :key="index" :class="{'small text-muted': line.fiat !== null}">
                          <small v-if="line.fiat !== null" class="text-muted me-1">{{ line.fiat }}</small>{{ numberFormatter.formatMoney(line.sum, usdtSubunits) }}
                          <small v-if="line.percent !== null" class="text-muted ms-1">({{ line.percent }})</small>
                        </div>
                      </td>
                      <template v-if="partners.length > 0">
                        <td v-for="partner in partners" :key="partner.userId">
                          <template v-for="(sums, takerCurrency) in (item.partnerRewardSums[partner.userId] ?? {})" :key="takerCurrency">
                            <div v-for="(sum, currency) in sums" :key="currency">
                              <small class="text-muted me-1">{{ takerCurrency }}</small>{{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                              <small class="text-muted ms-1" v-if="formatPercent(item.partnerPercents?.[partner.userId]?.[takerCurrency]?.[currency]) !== null">
                                ({{ formatPercent(item.partnerPercents?.[partner.userId]?.[takerCurrency]?.[currency]) }})
                              </small>
                              <small class="text-muted d-block" v-if="partnerBreakdown(item, partner.userId, takerCurrency, currency)">
                                {{ partnerBreakdown(item, partner.userId, takerCurrency, currency) }}
                              </small>
                            </div>
                          </template>
                        </td>
                        <td>
                          <template v-for="(sums, takerCurrency) in item.restSums" :key="takerCurrency">
                            <div v-for="(sum, currency) in sums" :key="currency">
                              <small class="text-muted me-1">{{ takerCurrency }}</small>{{ numberFormatter.formatMoney(sum, usdtSubunits) }}
                              <small class="text-muted ms-1" v-if="formatPercent(item.restPercents?.[takerCurrency]?.[currency]) !== null">
                                ({{ formatPercent(item.restPercents?.[takerCurrency]?.[currency]) }})
                              </small>
                            </div>
                          </template>
                        </td>
                      </template>
                    </tr>
                    </tbody>
                  </template>
                    <tbody>
                    <tr>
                      <td colspan="20"></td>
                    </tr>
                    </tbody>
                  </template>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import {createExportTask} from "@/service/exportTaskCreate";
import {useNotification} from "@kyvg/vue3-notification";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {debounce, helper} from "@/service/CommonHelper";
import {DealStatus} from "@/models/enum/DealStatus";
import {Direction} from "@/models/enum/Direction";
import {Dictionary} from "@/types";
import MerchantDTO from "@/models/MerchantDTO";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import TraderDTO from "@/models/TraderDTO";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import UserDTO from "@/models/UserDTO";
import MerchantMultiselect from "@/components/MerchantMultiselect.vue";
import StoreMultiselect from "@/components/StoreMultiselect.vue";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";
import DevicesMultiselect from "@/components/DevicesMultiselect.vue";
import TeamLeadMultiselect from "@/components/TeamLeadMultiselect.vue";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import {DatePicker} from "v-calendar";
import Multiselect from "vue-multiselect";
import moment from "moment";
import MoneyDTO from "@/models/MoneyDTO";
import PaginationDTO from "@/models/PaginationDTO";
import {TurnoverSummaryItemDTO, TurnoverSummaryPartnerDTO} from "@/models/TurnoverSummaryDTO";

const api = new APIClient();

const notification = useNotification()

const METRICS = ['completed', 'canceled', 'total'];
const TOTAL_GROUP_ID = '0';
const EXPORT_SYSNAME = 'turnover_summary';
const PERCENT_BASE_COLUMN = 'traderSums';
const MONEY_COLUMNS = [
  'traderSums',
  'storeSums',
  'storeFeeSums',
  'traderRewardSums',
  'teamLeadRewardSums',
  'referralRewardSums',
  'serviceRewardSums',
];

interface TurnoverSummaryCellLine {
  fiat: string|null,
  sum: MoneyDTO,
  percent: string|null,
}

interface TurnoverSummaryGroup {
  groupId: string,
  store: MerchantStoreDTO|null,
  trader: TraderDTO|null,
  directions: string[],
  itemsByDirection: Dictionary<TurnoverSummaryItemDTO[]>,
}

export default defineComponent({
  components: {
    LoaderWrapper,
    ConfirmModal,
    MerchantMultiselect,
    StoreMultiselect,
    TraderMultiselect,
    TrafficGroupMultiselect,
    DevicesMultiselect,
    TeamLeadMultiselect,
    PayMethodIcon,
    DatePicker,
    Multiselect,
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const deviceMultiselect = ref<InstanceType<typeof DevicesMultiselect> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    const state = reactive({
      usdtSubunits: 2,
      showByFiat: false,
      tradersFilter: [] as TraderDTO[],
      merchantsFilter: [] as MerchantDTO[],
      storesFilter: [] as MerchantStoreDTO[],
      trafficGroupsFilter: [] as TrafficGroupDTO[],
      devicesFilter: [] as TraderDeviceDTO[],
      teamLeadFilter: null as UserDTO|null,
      partners: [] as TurnoverSummaryPartnerDTO[],
      groups: [] as TurnoverSummaryGroup[],
      requestDTO: {
        groupBy: 'store',
        fromDate: moment().format('YYYY-MM-DD 00:00:00'),
        currency: null,
        amountFrom: null,
        amountTo: null,
        onlyProviders: null,
      } as any,
    });

    const onTraderListUpdate = debounce(() => {
      deviceMultiselect.value?.search('')
    }, 1000);

    const buildGroups = (items: TurnoverSummaryItemDTO[]): TurnoverSummaryGroup[] => {
      const groups = {} as Dictionary<TurnoverSummaryGroup>

      for (const item of items) {
        if (!groups[item.groupId]) {
          groups[item.groupId] = {
            groupId: item.groupId,
            store: null,
            trader: null,
            directions: [],
            itemsByDirection: {},
          }
        }

        if (!groups[item.groupId].itemsByDirection[item.direction]) {
          groups[item.groupId].itemsByDirection[item.direction] = []
        }

        groups[item.groupId].itemsByDirection[item.direction].push(item)
      }

      for (const group of Object.values(groups)) {
        for (const direction of [Direction.PAY_IN, Direction.PAY_OUT]) {
          if (!group.itemsByDirection[direction]) {
            continue;
          }

          group.itemsByDirection[direction].sort((a, b) => METRICS.indexOf(a.metric) - METRICS.indexOf(b.metric))
          group.directions.push(direction)
        }
      }

      return Object.values(groups)
    }

    const loadGroupEntities = async (groups: TurnoverSummaryGroup[], groupBy: string) => {
      const groupIds = groups.map((group) => group.groupId).filter((groupId) => groupId !== TOTAL_GROUP_ID)
      if (groupIds.length === 0) {
        return;
      }

      const byId = {} as Dictionary<TurnoverSummaryGroup>
      for (const group of groups) {
        byId[group.groupId] = group
      }

      if (groupBy === 'store') {
        const stores = (await api.merchantStores({limit: groupIds.length, offset: 0} as PaginationDTO, {ids: groupIds})).items;
        for (const store of stores) {
          if (byId[store.id.toString()]) {
            byId[store.id.toString()].store = store
          }
        }
        return;
      }

      const traders = (await api.traders({limit: groupIds.length, offset: 0} as PaginationDTO, {ids: groupIds})).items;
      for (const trader of traders) {
        if (byId[trader.id.toString()]) {
          byId[trader.id.toString()].trader = trader
        }
      }
    }

    const rewardColumnsCount = computed(() => 4 + (state.partners.length > 0 ? state.partners.length + 1 : 0))

    const partnerBreakdown = (item: TurnoverSummaryItemDTO, userId: number, takerCurrency: string, currency: string): string => {
      const revenue = item.partnerRevenueRewardSums?.[userId]?.[takerCurrency]?.[currency]
      const turnover = item.partnerTurnoverRewardSums?.[userId]?.[takerCurrency]?.[currency]

      if (!revenue && !turnover) {
        return ''
      }

      const format = (sum?: MoneyDTO) => numberFormatter.formatNumber(parseFloat(sum?.amount ?? '0'), state.usdtSubunits)

      return `${helper.trans('statistic.turnoverSummary.partner.revenue')} ${format(revenue)}`
        + ` \u00b7 ${helper.trans('statistic.turnoverSummary.partner.turnover')} ${format(turnover)}`
    }

    const formatPercent = (value?: string|null): string|null => {
      if (value === undefined || value === null || value === '') {
        return null
      }

      return `${numberFormatter.formatNumber(parseFloat(value), 2)}%`
    }

    const cellLines = (item: TurnoverSummaryItemDTO, column: string): TurnoverSummaryCellLine[] => {
      const source = item as any
      const lines: TurnoverSummaryCellLine[] = []

      for (const [currency, sum] of Object.entries(source[column] ?? {})) {
        lines.push({
          fiat: null,
          sum: sum as MoneyDTO,
          percent: column === PERCENT_BASE_COLUMN ? null : formatPercent(item.percents?.[column]?.[currency]),
        })
      }

      if (!state.showByFiat) {
        return lines
      }

      for (const [fiat, sumsByColumn] of Object.entries(item.sumsByFiat ?? {})) {
        for (const [currency, sum] of Object.entries((sumsByColumn as any)?.[column] ?? {})) {
          lines.push({
            fiat,
            sum: sum as MoneyDTO,
            percent: column === PERCENT_BASE_COLUMN ? null : formatPercent(item.percentsByFiat?.[fiat]?.[column]?.[currency]),
          })
        }
      }

      return lines
    }

    const metricRowClass = (metric: string) => ({
      'text-success': metric === 'completed',
      'text-info': metric === 'canceled',
      'fw-bold': metric === 'total',
    })

    const buildParams = (): any => {
      state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)
      state.requestDTO.storeIds = state.storesFilter.map((value) => value.id)
      state.requestDTO.merchantIds = state.merchantsFilter.map((value) => value.id)
      state.requestDTO.trafficGroupsIds = state.trafficGroupsFilter.map((value) => value.id)
      state.requestDTO.deviceIds = state.devicesFilter.map((value) => value.id)
      state.requestDTO.teamLeadId = state.teamLeadFilter?.id

      const params: any = {
        ...state.requestDTO,
        fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
        toDate: dateHelper.toUTC(state.requestDTO.toDate),
        amountFrom: state.requestDTO.amountFrom,
        amountTo: state.requestDTO.amountTo,
      };

      if (state.requestDTO.onlyProviders === '1' || state.requestDTO.onlyProviders === true) {
        params.onlyProviders = 1;
      }

      return params
    }

    const startExport = async () => {
      try {
        await createExportTask(store, confirmModal, EXPORT_SYSNAME, buildParams())
        notification.notify({type: 'success', title: helper.trans('export_tasks.export_started')})
      } catch (e) {
        notification.notify({type: 'error', title: helper.trans('labels.error'), text: helper.trans('export_tasks.generation_error')})
      }
    }

    const loadSummary = async () => {
      loader.value?.show()

      try {
        const params = buildParams();

        const response = await api.statisticTurnoverSummary(params);

        state.partners = response.partners ?? []

        const groups = buildGroups(response.items ?? [])
        await loadGroupEntities(groups, response.groupBy ?? state.requestDTO.groupBy)
        state.groups = groups
      } finally {
        loader.value?.hide();
      }
    }

    const clearFilters = async () => {
      state.tradersFilter = [];
      state.storesFilter = [];
      state.merchantsFilter = [];
      state.devicesFilter = [];
      state.trafficGroupsFilter = [];
      state.teamLeadFilter = null;
      state.requestDTO = {
        groupBy: 'store',
        fromDate: moment().format('YYYY-MM-DD 00:00:00'),
        options: [],
        methods: [],
        onlyProviders: null,
      }
    }

    const applyFilters = async () => {
      loadSummary()
    }

    onMounted(() => {
      loadSummary()
    });

    return {
      ...toRefs(state),
      loader,
      deviceMultiselect,
      confirmModal,
      moneyColumns: MONEY_COLUMNS,
      cellLines,
      formatPercent,
      startExport,
      store,
      helper,
      dateHelper,
      numberFormatter,
      DealStatus,
      Direction,
      rewardColumnsCount,
      partnerBreakdown,
      metricRowClass,
      onTraderListUpdate,
      applyFilters,
      clearFilters,
    }
  }
})
</script>
